// create a container and set the full-size image as its background
function createOverlay(image) {
  const overlayImage = document.createElement('img');
  overlayImage.setAttribute('src', `${image.src}`);
  overlay = document.createElement('div');
  prepareOverlay(overlay, overlayImage);

  image.style.opacity = '50%';
  toggleLoadingSpinner(image);

  overlayImage.onload = () => {
    toggleLoadingSpinner(image);
    image.parentElement.insertBefore(overlay, image);
    image.style.opacity = '100%';
  };

  return overlay;
}

function prepareOverlay(container, image) {
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  container.style.backgroundImage = `url('${image.src}')`;
  container.style.backgroundColor = 'var(--gradient-background)';
}

function toggleLoadingSpinner(image) {
  const loadingSpinner = image.parentElement.parentElement.querySelector(`.loading__spinner`);
  loadingSpinner.classList.toggle('hidden');
}

function moveWithHover(image, event, zoomRatio) {
  // calculate mouse position
  const ratio = image.height / image.width;
  const container = event.target.getBoundingClientRect();
  const xPosition = event.clientX - container.left;
  const yPosition = event.clientY - container.top;
  const xPercent = `${xPosition / (image.clientWidth / 100)}%`;
  const yPercent = `${yPosition / ((image.clientWidth * ratio) / 100)}%`;

  // determine what to show in the frame
  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlay.style.backgroundSize = `${image.width * zoomRatio}px`;
  console.log('overlay.style.backgroundSize', overlay.style.backgroundSize);
  console.log('zoomRatio', zoomRatio);
  console.log('image.width', image.width);
}

function magnify(image, zoomRatio) {
  const overlay = createOverlay(image);
  overlay.onclick = () => overlay.remove();
  overlay.onmousemove = (event) => moveWithHover(image, event, zoomRatio);
  overlay.onmouseleave = () => overlay.remove();
}


function enableZoomOnHover(zoomRatio) {
    const images = document.querySelectorAll('.image-magnify-hover');
    images.forEach((image) => {
      image.onclick = (event) => {
        if (window.innerWidth < 990) {
          event.preventDefault();

          const modalOpener = image.closest('.product__modal-opener');
          if (modalOpener) {
            const mediaId = modalOpener.querySelector('.product__media-toggle').dataset.mediaId;
            const modal = document.querySelector('product-modal');

            if (modal) {
              modal.show(modalOpener);

              const modalContent = modal.querySelector('.product-media-modal__content');
              if (modalContent) {
                modalContent.querySelectorAll('[data-media-id]').forEach(media => {
                  media.classList.remove('active');
                });
                const targetMedia = modalContent.querySelector(`[data-media-id="${mediaId}"]`);
                if (targetMedia) {
                  targetMedia.classList.add('active');
                }
              }
            }
          }
        } else {
          magnify(image, zoomRatio);
          moveWithHover(image, event, zoomRatio);
        }
      };
    });

  const hoverElement = document.querySelector('.product__media-wrapper .glide__slide--active .image-magnify-hover');
  if (hoverElement) {
        hoverElement.addEventListener('mouseenter', function onHover() {
      const overlay = document.querySelector('.product__media-wrapper .glide__slide--active #swipe-overlay-message');
        overlay.classList.remove('opacity-0');
      overlay.classList.add('opacity-100');
      setTimeout(() => {
        overlay.classList.remove('opacity-100');
        overlay.classList.add('opacity-0');
      }, 2000);

      sessionStorage.setItem('overlayShown', 'true');

      hoverElement.removeEventListener('mouseenter', onHover);
    });
  }
}

enableZoomOnHover(2.5);
